(function () {
  'use strict';

  angular.module('ringbaPortal').filter('tagIdToText', tagIdToText);

  function tagIdToText(
    _,
    $filter
  ) {
    'ngInject';

    return function (tagId, tags, tagIds) {
      if (!tags) {
        return;
      }

      if (tagIds) {
        const tagToText = [];
        tagIds.forEach(function (t) {
          tagToText.push(_getTagDescription(t, tags));
        });
        return tagToText.join(' | ');
      }

      return _getTagDescription(tagId, tags);
    };

    function _getTagDescription (tagId, tags) {
      if (!tags) {
        return;
      }
      const foundTag = _.find(tags, function (tag) {
        return !tag ? false : (tag.tagType + ':' + tag.tagName) === tagId;
      });
      if (!foundTag) {
        return;
      }

      return $filter('selectedTagsToText')([foundTag]);
    }
  }
})();
